export const API = {
  // admin

  CREATE_COUPON: () => `admin/createCoupon`,
  GET_ALL_COUPON: () => `admin/getAllCoupons`,
  DELETE_COUPON: () => `admin/deleteCoupon`,
  CREATE_GIFT_CARD: () => `admin/createGiftCard`,
  GET_ALL_GIFT_CARD: () => `admin/getAllGiftCards`,
  DELETE_GIFT_CARD: () => `admin/deleteGiftCard`,
  REGISTER_USER: () => `admin/register`,

  LOGIN_USER: () => `auth/signIn`,
  USER_STATUS: () => `user/getUserStatus`,
  GET_BOOKING_BY_DATES: () => `admin/booking/getBooking/filterByDateRange`,

  LOGIN_REGISTER: () => `admin/register`,

  // new Admin
  GET_ALL_BOOKINGS: () => `admin/booking/getBooking/all`,
  GET_BOOKING_BY_DATES_RANGE: () =>
    `admin/booking/getBooking/filterByDateRange`,
  SEARCH_BOOKING: () => `admin/booking/getBooking/search`,
  GET_ALL_EMPLOYEE: () => `admin/employee/getAll`,
  ASSIGN_EMPLOYEE: () => `admin/employee/assignEmployees`,
  DISMISS_EMPLOYEE: () => `admin/employee/dismissEmployees`,
  // admin

  GET_BOOKING_BY_ID: () => `admin/getBooking/getById`,
  GET_BOOKING_BY_STATUS: () => `admin/getBooking/getByBookingStatus`,
  GET_BOOKING_BY_DATES_AND_STATUS: () =>
    `admin/getBooking/getByBookingDatesAndBookingStatus`,
  GET_CUSTOMER_BY_SEARCH: () => `admin/customer/search`,

  //emp
  GET_ALL_ASSIGNED_BOOKINGS: () => `employee/bookings`,

  GET_VEHICLES: () => `public/getServiceOptions`,
  GET_SERVICES: () => `public/getServiceDescription`,

  CREATE_BOOKING: () => `admin/booking/create`,
  UPDATE_BOOKING: () => `admin/booking/edit`,
  UPDATE_BOOKING_STATUS: () => `admin/booking/updateBookingStatus`,
  DELETE_BOOKING: () => `admin/booking/deleteBooking`,
  REGISTER_EMPLOYEE: () => `admin/emp/registerEmployee`,
  DELETE_EMPLOYEE: () => `admin/emp/deleteEmployee`,
  UPDATE_EMPLOYEE: () => `admin/emp/updateEmployee`,
  GET_EMPLOYEE_BY_EMP_ID: () => `admin/emp/getEmployeeByEmpId`,
  GET_AVAILABLE_EMPLOYEES: () => `admin/booking/availableEmployees`,
  RESEND_CONFIRMATION_MESSAGE: () => `admin/booking/confirmation/resendMsg`,
  RESEND_CONFIRMATION_MAIL: () => `admin/booking/confirmation/resendMail`,
  RESEND_CONFIRMATION_EVENT: () => `admin/booking/confirmation/resendEvent`,
  REMINDER_MESSAGE: () => `admin/booking/reminder/msg`,
  REMINDER_MAIL: () => `admin/booking/reminder/mail`,
  NEWSLETTER: () => `admin/newsletter`,
  GET_BOOKING_SLOTS: () => `booking/getBookingSlots`,
  UPLOAD_IMAGE: () => `upload`,
  SEND_EMAIL: () => `admin/sendEmail`,
}
